<template>
  <div class="page" :style="{ height: fixedHeight + 'px' }">
    <div class="searchbox" v-if="activeName == '1'">
      <div
        style="align-items: center; display: flex; height: 72px; width: 100%"
      >
        <div style="margin-right: 10px">
          <el-input
            style="width: 160px; margin-right: 10px; margin-left: 10px"
            placeholder="请输入名称"
            v-model="params.keyword"
            @keyup.enter.native="clickSearch"
            clearable
            size="small"
          ></el-input>
          <el-button
            @click="clickSearch"
            icon="el-icon-search"
            type="warning"
            size="small"
            >搜索</el-button
          >
        </div>
        <div style="margin-right: 10px">
          <el-select
            v-model="params.shopId"
            placeholder="请选择"
            clearable
            @change="clickSearch"
            size="small"
            style="width: 120px"
          >
            <el-option
              v-for="item in this.$store.state.userInfo.shops"
              :key="item.shop_id"
              :label="item.shop_name"
              :value="item.shop_id"
            >
            </el-option>
          </el-select>
        </div>
        <div style="margin-right: 10px">
          <el-select
            v-model="params.applytype"
            placeholder="请选择种类"
            clearable
            @change="clickSearch"
            size="small"
            style="width: 120px"
          >
            <el-option label="通用" value="0"></el-option>
            <el-option label="犬用" value="2"></el-option>
            <el-option label="猫用" value="1"></el-option>
          </el-select>
        </div>
        <div style="flex: 1; text-align: right">
          <el-button
            icon="el-icon-plus"
            type="warning"
            @click="addGoods()"
            size="small"
            style="margin-right: 10px"
            v-if="$buttonAuthority('chanpin-fictitious-add')"
          >
            新建<span v-if="activeName == '1'">虚拟卡</span>
            <!-- <span v-if="activeName=='2'">优惠劵</span> -->
          </el-button>
        </div>
      </div>
    </div>
    <!-- 优惠券 -->
    <div class="searchbox" v-if="activeName == '2'">
      <el-form :inline="true" ref="ruleForm" :model="couponParams">
        <div
          style="height: 72px; display: flex; align-items: center; width: 100%"
        >
          <div style="margin: 0 10px 0 10px">
            <el-input
              style="width: 160px; margin-right: 10px"
              placeholder="请输入名称"
              v-model="couponParams.keyword"
              @keyup.enter.native="clickSearch"
              clearable
              size="small"
            >
            </el-input>
            <el-button
              @click="clickSearch"
              icon="el-icon-search"
              type="warning"
              size="small"
              >搜索</el-button
            >
          </div>
          <div style="display: flex; align-items: center">
            <el-form-item label="使用场景" style="margin-bottom: 0px">
              <el-select
                style="width: 120px"
                size="small"
                v-model="couponParams.useScene"
                placeholder="请选择"
                @change="clickSearch()"
              >
                <el-option label="线上" :value="Number('1')"></el-option>
                <el-option label="线下" :value="Number('2')"></el-option>
                <!-- <el-option label="全部" :value="Number('0')"></el-option> -->
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item
              label="活动时间"
              prop="type_id"
              style="margin-bottom: 0px"
            >
              <el-col :span="10">
                <el-date-picker
                  style="width: 160px"
                  @change="clickSearch()"
                  size="small"
                  type="date"
                  value-format="timestamp"
                  placeholder="选择日期"
                  v-model="couponParams.receiveStartTime"
                >
                </el-date-picker>
              </el-col>
              <el-col
                class="line"
                :span="4"
                style="text-align: center; padding-left: 10px"
                >至</el-col
              >
              <el-col :span="10">
                <el-date-picker
                  style="width: 160px"
                  @change="clickSearch()"
                  size="small"
                  placeholder="选择时间"
                  value-format="timestamp"
                  v-model="couponParams.receiveEndTime"
                >
                </el-date-picker>
              </el-col>
            </el-form-item>
          </div>
          <div style="flex: 1; text-align: right; margin-right: 10px">
            <el-button
              icon="el-icon-plus"
              type="warning"
              @click="addGoods()"
              size="small"
              v-if="$buttonAuthority('chanpin-fictitious-add')"
            >
              新建<span v-if="activeName == '2'">优惠劵</span></el-button
            >
          </div>
        </div>
      </el-form>
    </div>
    <div class="searchbox cardBox" v-if="activeName == '3'">
      <div class="searchboxL">
        <el-input
          style="width: 160px; margin-right: 10px"
          placeholder="请输入"
          v-model="cardKeyword"
          @keyup.enter.native="clickSearch"
          clearable
          size="small"
        ></el-input>
        <el-button
          @click="clickSearch"
          icon="el-icon-search"
          type="warning"
          size="small"
          >搜索</el-button
        >
        <div class="labelName">状态</div>
        <el-select
          v-model="cardState"
          placeholder="请选择状态"
          size="small"
          style="width: 80px"
          @change="clickSearch"
        >
          <el-option
            v-for="(item, index) in cardOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="searchboxR">
        <el-button
          icon="el-icon-plus"
          type="warning"
          @click="handleUpdateClick(1)"
          size="small"
          v-if="$buttonAuthority('chanpin-fictitious-add')"
          >新建卡模板</el-button
        >
      </div>
    </div>
    <div class="con" :style="{ height: fixedHeight - 80 + 'px' }">
      <div class="left">
        <el-button
          style="margin-left: 20px"
          size="mini"
          @click="addProductType('')"
          >添加</el-button
        >
        <el-button size="mini" type="warning" @click="resetProductType"
          >重置</el-button
        >
        <el-tree
          class="elTree"
          style="margin-top: 10px"
          v-if="categoryData[0]"
          :data="categoryData[0].children"
          :highlight-current="isHighlight"
          node-key="id"
          default-expand-all
          :expand-on-click-node="false"
          :render-content="renderContent"
          @node-click="handleNodeClick"
        >
        </el-tree>
      </div>
      <div class="tableView">
        <!-- 第一个洗澡卡 -->
        <div class="table" v-if="activeName == '1'">
          <el-table :data="cardData">
            <el-table-column prop="title" label="名称"> </el-table-column>
            <el-table-column prop="name" label="适用宠物">
              <template slot-scope="scope">
                <span>{{ scope.row.apply_type.title }}</span>
              </template>
            </el-table-column>

            <el-table-column label="分类">
              <template slot-scope="scope">
                <span v-if="scope.row.category_info">{{
                  scope.row.category_info.name
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="数量">
              <template slot-scope="scope">
                <span>{{ scope.row.total_count }}</span>
              </template>
            </el-table-column>
            <el-table-column label="期限(天)">
              <template slot-scope="scope">
                <span>{{ scope.row.valid_days }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180px">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-edit"
                  size="small"
                  @click="edit(scope.row, 1)"
                  v-if="$buttonAuthority('chanpin-fictitious-edit')"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  icon="el-icon-delete"
                  size="small"
                  @click="deleted(scope.row.virtualId, 1)"
                  v-if="$buttonAuthority('chanpin-fictitious-del')"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <page
            :total="total"
            :page="params.pageIndex"
            @change="changePage"
            style="padding: 20px"
          ></page>
        </div>
        <!-- 优惠券 -->
        <div class="table" v-if="activeName == '2'">
          <el-table default-expand-all :data="couponData">
            <el-table-column
              align="center"
              label-class-name="lablename"
              label="优惠劵名称"
              prop="coupon_name"
            >
            </el-table-column>
            <el-table-column
              width="180px"
              align="center"
              label-class-name="lablename"
              label="活动规格"
              prop="type"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.activity_type == 1"
                  >满{{ scope.row.money_top }}减{{
                    scope.row.money_reduce
                  }}</span
                >
                <span v-if="scope.row.activity_type == 2"
                  >满{{ scope.row.rebate_top }}打{{ scope.row.rebate*10}}折
                  最高抵扣{{ scope.row.rebate_limit }} 元</span
                >
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              width="180px"
              label-class-name="lablename"
              label="活动时间"
              prop="receive_start_time"
            >
              <template slot-scope="scope">
                <span>{{
                  $public.FTime(scope.row.receive_start_time, "YYYY-MM-DD")
                }}</span>
                至
                <span>{{
                  $public.FTime(scope.row.receive_end_time, "YYYY-MM-DD")
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              width="70px"
              align="center"
              label-class-name="lablename"
              label="使用场景"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.use_scene == 1">线上</span>
                <span v-if="scope.row.use_scene == 2">线下</span>
                <span v-if="scope.row.use_scene == 0">全部</span>
              </template>
            </el-table-column>
            <el-table-column
              width="90px"
              align="center"
              label-class-name="lablename"
              label="活动类型"
              prop="activity_type"
            >
              <template slot-scope="scope">
                <span
                  v-if="
                    scope.row.category_info._id !== '6053056e1b5ad39d50d004c7'
                  "
                >
                  <span v-if="scope.row.activity_type == 1">满N元减M元</span>
                  <span v-if="scope.row.activity_type == 2">满N元打M折</span>
                </span>
                <span v-else> 抵扣 </span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label-class-name="lablename"
              label="说明"
              prop="remark"
              width="150px"
            >
              <template slot-scope="scope">
                <div
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  <span class="remark">{{ scope.row.remark }}</span>
                  <el-popover
                    v-if="scope.row.remark"
                    placement="top-start"
                    width="200"
                    trigger="hover"
                    :content="scope.row.remark"
                  >
                    <el-button
                      slot="reference"
                      type="text"
                      icon="el-icon-view"
                    ></el-button>
                  </el-popover>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              width="180px"
              align="center"
              label-class-name="lablename"
              label="使用时间"
              prop="use_start_time"
            >
              <template slot-scope="scope">
                <span>{{
                  $public.FTime(scope.row.use_start_time, "YYYY-MM-DD")
                }}</span>
                至
                <span>{{
                  $public.FTime(scope.row.use_end_time, "YYYY-MM-DD")
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              width="70px"
              align="center"
              label-class-name="lablename"
              label="过期时间"
              prop="use_start_time"
            >
              <template slot-scope="scope">
                <span
                  style="color: #292b2c"
                  v-if="scope.row.limit_type == 0"
                ></span>
                <span style="color: #292b2c" v-if="scope.row.limit_type == 1"
                  >{{ scope.row.use_days }}天</span
                >
              </template>
            </el-table-column>
            <el-table-column
              width="70px"
              align="center"
              label-class-name="lablename"
              label="活动状态"
              prop="activity_state"
            >
              <template slot-scope="scope">
                <span style="color: #292b2c" v-if="scope.row.status == 1"
                  >下架</span
                >
                <span style="color: #e3a92d" v-else-if="scope.row.status == 2"
                  >上架</span
                >
                <span style="color: crimson" v-else-if="scope.row.status == 0"
                  >删除</span
                >
              </template>
            </el-table-column>
            <el-table-column
              min-width="300px"
              align="center"
              label-class-name="lablename"
              label="操作"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="info"
                  v-if="scope.row.status == 1"
                  @click="handleDetele(scope.row)"
                  >删除</el-button
                >
                <el-button
                  size="mini"
                  type="info"
                  v-if="scope.row.status == 2"
                  @click="offshelf(scope.row)"
                  >下架</el-button
                >
                <el-button
                  size="mini"
                  type="primary"
                  v-if="scope.row.status == 1"
                  @click="onshelf(scope.row)"
                  >上架</el-button
                >
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="上架后不能编辑"
                  placement="top-start"
                >
                  <el-button
                    size="mini"
                    :disabled="scope.row.status == 2"
                    type="success"
                    @click="edit(scope.row, 2, 'edit')"
                    v-if="$buttonAuthority('chanpin-fictitious-edit')"
                    >编辑</el-button
                  >
                </el-tooltip>
                <el-button
                  size="mini"
                  type="warning"
                  @click="see(scope.row,2,'see')"
                  >查看</el-button
                >
                <el-button
                  size="mini"
                  type="warning"
                  @click="usecoupon(scope.row)"
                  >领取记录</el-button
                >
                <el-button
                  size="mini"
                  :disabled="scope.row.status == 1"
                  @click="getGive(scope.row)"
                  >赠送</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <page
            :total="total"
            :page="couponParams.pageIndex"
            @change="changePage"
            style="padding: 20px"
          >
          </page>
        </div>
        <!-- 第三个礼品卡 -->
        <div class="table" v-if="activeName == '3'">
          <el-table :data="cardTable" style="width: 100%" key="3">
            <el-table-column prop="cardType.title" label="分类">
            </el-table-column>
            <el-table-column prop="name" label="名称"> </el-table-column>
            <el-table-column prop="cardMoney" label="面额"> </el-table-column>
            <el-table-column label="有效期">
              <template><span>不限</span></template>
            </el-table-column>
            <el-table-column prop="address" label="状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1">已启用</span>
                <span v-if="scope.row.status == 0">已禁用</span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  @click="handleUpdateClick(2, scope.row)"
                  type="text"
                  size="small"
                  v-if="$buttonAuthority('chanpin-fictitious-edit')"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handleNavDetailClick(scope.row)"
                  >详情</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handleDeleteClick(scope.row)"
                  v-if="$buttonAuthority('chanpin-fictitious-del')"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <page
            :total="cardTotal"
            :page="cardPageIndex"
            @change="changePage"
            style="padding: 20px"
          ></page>
        </div>
      </div>
    </div>

    <el-dialog
      title="虚拟类型设置"
      :visible.sync="dialogProductType"
      width="30%"
      :close-on-click-modal="false"
    >
      <el-form ref="editProductParams" label-width="80px">
        <el-form-item label="类型名称">
          <el-input
            v-model="editProductParams.typeName"
            size="mini"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="warning" @click="onSubmitProductType"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="赠送"
      :visible.sync="dialogGive"
      width="50%"
      destroy-on-close
      :close-on-click-modal="false"
    >
      <el-autocomplete
        class="inline-input"
        v-model="keyword"
        :fetch-suggestions="querySearch"
        placeholder="请输入内容"
        size="mini"
        style="width: 200px"
        @select="handleSelectUser"
      >
        <template slot-scope="{ item }">
          <div class="name">
            {{ item.basic_info.nick_name }}{{ item.basic_info.user_mobile }}
          </div>
        </template>
      </el-autocomplete>

      <el-table :data="user" style="width: 100%">
        <el-table-column prop="member_name" label="用户名" width="180">
        </el-table-column>
        <el-table-column prop="member_mobile" label="手机号" width="180">
        </el-table-column>
        <el-table-column prop="address" label="操作">
          <template slot-scope="scope">
            <div>
              <span
                >赠送数量
                <el-input-number
                  size="mini"
                  v-model="scope.row.coupon_count"
                  :min="1"
                  :max="50"
                  label="描述文字"
                ></el-input-number>
                张</span
              >
              <el-button
                style="margin-left: 10px"
                type="text"
                icon="el-icon-close"
                @click="deleteduser(scope.row, scope.$index)"
              ></el-button>
            </div>
            <div v-if="scope.row.coupon_count >= 50" style="color: red">
              每人可赠送限制50张
            </div>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="warning"
          :loading="loadding"
          size="mini"
          @click="giveCoupon"
          >赠送</el-button
        >
      </span>
    </el-dialog>

    <!-- 新建/编辑卡模板 -->
    <div v-if="drawerEditCard_state">
      <drawerEditCard
        @closeOn="handleCardClose"
        :comState="drawerEditCard_state"
        :navType="navType"
        :navData="navData"
      ></drawerEditCard>
    </div>
  </div>
</template>

<script>
import page from "../../../components/page.vue";
import drawerEditCard from "./drawerEditCard.vue";
import {
  getVirtualCardGroupList,
  getCoupon, //优惠券
  deleteVirtualCardGroup,
  onselfCoupon_new,
  getUseList,
  sendCoupon,
  getProductTypeList, //tree分类
  setProductType,
  deleteProductType,
  getProductTypeDl,
} from "../../../api/productApi.js";
export default {
  components: {
    page,
    drawerEditCard,
  },
  data() {
    return {
      fixedHeight: "",
      activeName: "1",
      cardData: [],
      couponData: [],
      cardParams: {
        pageIndex: 0,
        pageSize: 0,
        keyword: "",
        applytype: "",
        categoryId: "",
        shopId: "",
      },
      couponParams: {
        keyword: "",
        useScene: 2,
        receiveStartTime: "",
        receiveEndTime: "",
        activity_type: 0,
        money_top: 0,
        money_reduce: 0,
        pageIndex: 1,
        pageSize: 10,
        categoryId: "",
        appShowStatus: "",
      },
      params: {
        pageIndex: 1,
        pageSize: 10,
        keyword: "",
        applytype: "",
        shopId: "",
      },
      isHighlight: true,

      total: 0,
      productTypeIds: [],
      categoryData: [],
      dialogProductType: false,
      editProductParams: {
        status: 1,
        category: "虚拟",
        typeName: "",
        parentId: "",
      },

      storeIds: [],
      dialogGive: false,
      user: [],
      userList: [],
      id: "",
      loadding: false,
      keyword: "",

      // 礼品卡
      cardPageIndex: 1,
      cardPageSize: 10,
      cardState: "",
      cardOptions: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "启用",
          value: "1",
        },
        {
          label: "禁用",
          value: "0",
        },
      ],
      cardKeyword: "", //搜索
      cardType: "", //卡类型
      cardTable: [], //卡列表
      cardTotal: 0,
      drawerEditCard_state: false,
      navType: 0, //跳转类型
      navData: null, //跳转数据
    };
  },

  methods: {
    //跳转详情
    handleNavDetailClick(row) {
      let query = {
        navRow: JSON.stringify(row),
      };
      this.$router.push({
        path: "cardDetail",
        query,
      });
    },
    // 删除优惠券
    handleDetele(row) {
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(row);
          let params = {
            id: row.id,
          };
          this.$http
            .delete(
              process.env.VUE_APP_Url_baseData + "/api/product/coupons",
              params
            )
            .then((res) => {
              if (res.code == 0) {
                this.$message({
                  type: "success",
                  message: "已删除",
                });
                this.getCoupon();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //删除卡模板
    handleDeleteClick(row) {
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(row);
          let params = {
            id: row.id,
          };
          this.$http
            .delete(
              process.env.VUE_APP_Url2 + "api/product/giftCard/template",
              params
            )
            .then((res) => {
              if (res.code == 0) {
                this.$message({
                  type: "success",
                  message: "已删除",
                });
                this.getCardList();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //新建
    handleUpdateClick(type, row) {
      this.navType = type;
      if (type == 2) {
        this.navData = row;
      }
      this.drawerEditCard_state = true;
    },
    //关闭卡弹框
    handleCardClose(val) {
      this.drawerEditCard_state = false;
      if (val.type == "submit") {
        this.getCardList();
      }
    },
    //卡列表
    getCardList() {
      let params = {
        pageIndex: this.cardPageIndex,
        pageSize: this.cardPageSize,
        keyword: this.cardKeyword,
        status: this.cardState,
        cardType: this.cardType,
      };
      this.$http
        .post(
          process.env.VUE_APP_Url2 + "api/product/giftCard/template/list",
          params
        )
        .then((res) => {
          if (res.code == 0) {
            this.cardTable = res.data.data;
            this.cardTotal = res.data.count;
          }
        });
    },
    // 卡
    getVirtualCardGroupList() {
      getVirtualCardGroupList(this.params).then((res) => {
        if (res.code == 0) {
          this.cardData = res.data.data;
          this.total = res.data.count;
        }
      });
    },
    // 优惠券
    getCoupon() {
      let params = {
        pageIndex: this.couponParams.pageIndex,
        pageSize: this.couponParams.pageSize,
        keyword: this.couponParams.keyword,
        appShowStatus: this.couponParams.appShowStatus,
        categoryId: this.couponParams.categoryId,
        useScene: this.couponParams.useScene,
        receiveStartTime: "",
        receiveEndTime: "",
        activity_type: this.couponParams.activity_type,
      };
      if (this.couponParams.receiveStartTime) {
        params.receiveStartTime = (
          this.couponParams.receiveStartTime / 1000
        ).toString();
      } else {
        params.receiveStartTime = "";
      }

      if (this.couponParams.receiveEndTime) {
        params.receiveEndTime = (
          this.couponParams.receiveEndTime / 1000
        ).toString();
      } else {
        params.receiveEndTime = "";
      }

      getCoupon(params).then((res) => {
        if (res.code == 0) {
          console.log(res.data.data, "优惠券列表");
          this.couponData = res.data.data;
          this.total = res.data.count;
        }
      });
    },
    //搜索
    clickSearch() {
      if (this.activeName == "1") {
        this.params.pageIndex = 1;
        this.getVirtualCardGroupList();
      } else if (this.activeName == "2") {
        this.couponParams.pageIndex = 1;
        this.getCoupon();
      } else if (this.activeName == "3") {
        this.cardPageIndex = 1;
        this.getCardList();
      }
    },
    changePage(val) {
      if (this.activeName == "1") {
        this.params.pageIndex = val;
        this.getVirtualCardGroupList();
      } else if (this.activeName == "2") {
        this.couponParams.pageIndex = val;
        this.getCoupon();
      } else if (this.activeName == "3") {
        this.cardPageIndex = val;
      }
    },
    // 新建优惠券
    addGoods() {
      if (this.activeName == "1") {
        this.$router.push({
          path: "/fictitious/addfictitiouscard",
          query: {
            type: "add",
          },
        });
      } else if (this.activeName == "2") {
        this.$router.push({
          path: "/fictitious/addfictitiousgoods",
          query: {
            type: "add",
          },
        });
      }
    },
    getStoreInfo(shopinfo) {
      this.editParams.shop_info = shopinfo;
    },

    edit(row, type) {
      if (type == 1) {
        this.$router.push({
          path: "/fictitious/addfictitiouscard",
          query: {
            id: row.virtualId,
            type: "edit",
          },
        });
      } else if (type == 2) {
        this.$router.push({
          path: "/fictitious/addfictitiousgoods",
          query: {
            id: row.id,
            type: "edit",
          },
        });
      }
    },
    see(row, type) {
      if (type == 2) {
        this.$router.push({
          path: "/fictitious/addfictitiousgoods",
          query: {
            id: row.id,
            type: "see",
          },
        });
      }
    },
    deleted(id, type) {
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let http;
          if (type == 1) {
            http = deleteVirtualCardGroup({
              id,
            });
          }
          http.then((res) => {
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              if (type == 1) {
                this.getVirtualCardGroupList();
              }
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    lookdetail(id) {
      console.log(id);
    },

    addProductType(data) {
      if (data) {
        this.editProductParams.parentId = data.id;
        this.editProductParams.typeName = "";
        this.editProductParams.typeId = "";
      } else {
        this.editProductParams.parentId = this.categoryData[0].id;
        this.editProductParams.typeName = "";
      }

      this.dialogProductType = true;
    },

    onSubmitProductType() {
      if (!this.editProductParams.typeName) {
        this.$message({
          type: "warning",
          message: "类型名称不能为空",
        });
      } else {
        setProductType(this.editProductParams).then((res) => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "设置成功",
            });
            this.dialogProductType = false;
            this.getProductTypeList();
          }
        });
      }
    },
    remove(node, data) {
      this.$confirm(
        "请谨慎操作！此操作将永久删除此类型，那么关联此类型的服务将被波及?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          deleteProductType({
            id: data.id,
          }).then((res) => {
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getProductTypeList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    getProductTypeList() {
      getProductTypeList({
        category: "虚拟",
      }).then((res) => {
        if (res.code == 0) {
          this.categoryData = res.data;
          console.log(this.categoryData, "树分类");
        }
      });
    },
    editProductType(data) {
      console.log(data);
      this.dialogProductType = true;
      this.editProductParams.typeId = data.id;
      this.editProductParams.typeName = data.label;
      this.editProductParams.parentId = "";
    },
    // 点击优惠券每一个列表
    handleNodeClick(data) {
      if (data.code == "virtual_card") {
        this.params.categoryId = data.id;
        this.params.pageIndex = 1;
        this.activeName = "1";
        this.getVirtualCardGroupList();
      } else if (data.code == "gift_card") {
        this.couponParams.pageIndex = 1;
        if (data.id == "60210f916e6d952a3929f0f9") {
          this.cardType = "";
        } else if (data.id == "60210f916e6d952a3929f0fa") {
          this.cardType = "1";
        } else if (data.id == "60210f916e6d952a3929f0fb") {
          this.cardType = "2";
        }
        this.activeName = "3";
        this.getCardList();
      } else {
        this.couponParams.pageIndex = 1;
        this.couponParams.categoryId = data.id;
        this.activeName = "2";
        this.getCoupon();
      }
    },
    changeCategory(val) {
      if (val.length > 0) {
        getProductTypeDl({
          id: val[val.length - 1],
        }).then((res) => {
          if (res.code == 0) {
            // console.log("券的分类",res.data);
            this.editParams.basic_info.category_info["name"] = res.data.name;
            this.editParams.basic_info.category_info["_id"] = res.data._id;
            this.editParams.basic_info.category_list = res.data.parent_all;
          }
        });
      }
    },
    resetProductType() {
      this.isHighlight = false;
      this.params.categoryId = "";
      if (this.activeName == "1") {
        this.getVirtualCardGroupList();
      } else if (this.activeName == "2") {
        this.getCoupon();
      }
    },
    // 下架
    offshelf(row) {
          onselfCoupon_new({ id: row.id, status: 1 }).then((res) => {
            if (res.code == 0) {
              this.getCoupon();
            }
          });
        
    },
    // 上架
    onshelf(row) {
      onselfCoupon_new({ id: row.id, status: 2 }).then((res) => {
        if (res.code == 0) {
          this.getCoupon();
        }
      });
    },
    querySearch(queryString, cb) {
      this.getUseListData(queryString);
      this.timeout = setTimeout(() => {
        let userList = this.userList;
        console.log(userList);
        cb(userList);
      }, 1000);
    },
    getUseListData(queryString) {
      getUseList({
        keyword: queryString,
        hs_vip: -1,
        hs_pet: -1,
      }).then((res) => {
        if (res.code == 0) {
          this.userList = res.data.data;
        }
      });
    },
    handleSelectUser(data) {
      // console.log(data,"顾客data")
      this.user.push({
        member_id: data._id,
        member_name: data.basic_info.nick_name,
        member_mobile: data.basic_info.user_mobile,
        coupon_count: 1,
      });
    },
    deleteduser(row, index) {
      this.user.splice(index, 1);
    },
    getGive(row) {
      this.dialogGive = true;
      // console.log(row,"row11");
      (this.id = row.id), (this.user = []);
    },
    giveCoupon() {
      console.log(this.id, "row");
      this.loadding = true;
      sendCoupon({
        coupon_id: this.id,
        send_list: this.user,
      }).then((res) => {
        if (res.code == 0) {
          this.loadding = false;
          this.$message("赠送成功");
          this.dialogGive = false;
        }
      });
    },
    // 领取记录
    usecoupon(row) {
      this.$router.push({
        path: "/fictitious/usecoupon",
        query: { id: row.id },
      });
    },
    renderContent(h, { node, data }) {
      return (
        <span class="custom-tree-node"  v-if="$buttonAuthority('chanpin-goods-sort')">
          <span> {node.label} </span>{" "}
          <span class="custom-tree-btn">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-plus"
              on-click={() => this.addProductType(data)}
            >
              {" "}
            </el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              on-click={() => this.editProductType(data)}
            >
              {" "}
            </el-button>
            <el-button
              size="mini"
              type="text"
              icon="el-icon-delete"
              on-click={() => this.remove(node, data)}
            >
              {" "}
            </el-button>
          </span>{" "}
        </span>
      );
    },
  },
  created() {
    this.fixedHeight = document.documentElement.clientHeight - 86;
    if (this.$route.query.type) {
      if (this.$route.query.type == 1) {
        this.activeName = "1";
        this.getVirtualCardGroupList();
      } else if (this.$route.query.type == 2) {
        this.activeName = "2";
        this.getCoupon();
      }
    } else {
      this.getVirtualCardGroupList();
    }
    this.getProductTypeList();
  },
};
</script>

<style lang="scss" scoped>
.page {
  .searchbox {
    background-color: #fff;
    height: 72px;
  }

  .cardBox {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .searchboxL {
      padding-left: 10px;
      display: flex;
      align-items: center;

      .labelName {
        font-size: 14px;
        margin: 0 12px;
      }
    }

    .searchboxR {
      padding-right: 10px;
    }
  }

  .con {
    display: flex;
    margin-top: 10px;

    .left {
      width: 180px;
      background-color: #fff;
      margin-right: 20px;
      padding: 10px;

      &::-webkit-scrollbar {
        width: 4px;
        // height: 4px;
      }

      .elTree {
        font-size: 12px;

        ::v-deep .custom-tree-node {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 12px;
          padding-right: 8px;
        }

        ::v-deep .custom-tree-btn {
          display: none;
        }

        ::v-deep .custom-tree-node:hover .custom-tree-btn {
          display: block;
        }
      }
    }

    .tableView {
      flex: 1;
      background: #fff;
      overflow-x: scroll;
      overflow-y: scroll;
    }

    .table {
    }
  }
}

.remark {
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
